/**
 * Company / 회사·현장 관리 API 에러 → i18n 키만 담은 ErrorMessage
 */

import {
  getBackendI18nKeyFromResponse,
  getHttpStatus,
  getServerMessage,
  isNetworkError,
  looksLikeI18nKey,
  normalizeBackendI18nKey,
} from './apiError';
import type { ErrorMessage } from './types';

const COMPANY_ERRORS = {
  GENERIC: {
    title: 'company:error_occurred',
    message: 'company:error_occurred',
    type: 'error' as const,
  },
} as const;

/**
 * 회사/사이트/현장 매니저 등 company 도메인 API 실패 시 사용.
 */
export function parseCompanyApiError(error: unknown): ErrorMessage {
  if (!error) {
    return COMPANY_ERRORS.GENERIC;
  }

  if (isNetworkError(error)) {
    return {
      title: 'auth:network_error',
      message: 'auth:network_error_message',
      type: 'error',
    };
  }

  const fromBackend = getBackendI18nKeyFromResponse(error);
  if (fromBackend && looksLikeI18nKey(fromBackend)) {
    return {
      title: 'company:error_occurred',
      message: normalizeBackendI18nKey(fromBackend),
      type: 'error',
    };
  }

  const rawMsg = getServerMessage(error);
  if (rawMsg && looksLikeI18nKey(rawMsg)) {
    return {
      title: 'company:error_occurred',
      message: normalizeBackendI18nKey(rawMsg),
      type: 'error',
    };
  }

  switch (getHttpStatus(error)) {
    case 403:
      return {
        title: 'company:error_occurred',
        message: 'company:error_not_your_company_site',
        type: 'error',
      };
    case 404:
      return {
        title: 'company:error_occurred',
        message: 'company:error_company_not_found',
        type: 'error',
      };
    case 409:
      return {
        title: 'company:error_occurred',
        message: 'company:error_occurred',
        type: 'error',
      };
    case 500:
      return {
        title: 'company:error_occurred',
        message: 'company:error_occurred',
        type: 'error',
      };
    default:
      return COMPANY_ERRORS.GENERIC;
  }
}
